<ng-container *ngIf="block && block.type !== 'SOURCE_EXPLORER'">
  <section
    class="view-block"
    [ngClass]="{
      'view-section': block.type === 'SECTION',
      'view-tree': block.type === 'TREE',
      'view-notice': block.type === 'NOTICE',
      'view-document-header': block.type === 'DOCUMENT_HEADER',
      'view-party': block.type === 'PARTY',
      'view-terms': block.type === 'TERMS',
      'view-totals': block.type === 'TOTALS',
      'view-signature': block.type === 'SIGNATURE'
    }"
  >
    <div class="block-heading" *ngIf="block.title || block.description">
      <h5 *ngIf="block.title">{{ block.title }}</h5>
      <p *ngIf="block.description">{{ block.description }}</p>
    </div>

    <div
      class="field-grid"
      *ngIf="
        block.fields?.length &&
        block.type !== 'PARTY' &&
        block.type !== 'TERMS' &&
        block.type !== 'TOTALS' &&
        block.type !== 'SIGNATURE'
      "
    >
      <button type="button" class="field-value" *ngFor="let field of block.fields" (click)="select(field)">
        <span class="field-label">{{ field.label }}</span>
        <span class="field-data">{{ value(field) }}</span>
      </button>
    </div>

    <div class="party-card" *ngIf="block.type === 'PARTY' && block.fields?.length">
      <button
        type="button"
        class="party-field"
        [ngClass]="fieldClass(field)"
        *ngFor="let field of block.fields"
        (click)="select(field)"
      >
        <span class="field-label">{{ field.label }}</span>
        <span class="field-data">{{ value(field) }}</span>
      </button>
    </div>

    <div class="terms-list" *ngIf="block.type === 'TERMS' && block.fields?.length">
      <button type="button" class="term-field" *ngFor="let field of block.fields" (click)="select(field)">
        <span class="field-label">{{ field.label }}</span>
        <span class="field-data">{{ value(field) }}</span>
      </button>
    </div>

    <dl class="totals-list" *ngIf="block.type === 'TOTALS' && block.fields?.length">
      <div *ngFor="let field of block.fields">
        <dt>{{ field.label }}</dt>
        <dd>
          <button type="button" (click)="select(field)">{{ value(field) }}</button>
        </dd>
      </div>
    </dl>

    <div class="signature-list" *ngIf="block.type === 'SIGNATURE' && block.fields?.length">
      <button type="button" class="signature-field" *ngFor="let field of block.fields" (click)="select(field)">
        <span class="signature-value">{{ value(field) }}</span>
        <span class="field-label">{{ field.label }}</span>
      </button>
    </div>

    <div class="table-responsive" *ngIf="block.type === 'TABLE' && block.children?.length">
      <table class="table table-sm align-middle">
        <thead>
          <tr>
            <th *ngFor="let column of tableColumns">{{ column }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of block.children">
            <td *ngFor="let column of tableColumns">
              <ng-container *ngIf="fieldForColumn(row, column) as field">
                <button type="button" class="cell-source" (click)="select(field)">{{ value(field) }}</button>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="child-blocks" *ngIf="block.type !== 'TABLE'">
      <lib-edi-view-block
        *ngFor="let child of block.children"
        [block]="child"
        [nodeIndex]="nodeIndex"
        (sourceSelected)="sourceSelected.emit($event)"
      ></lib-edi-view-block>
    </div>
  </section>
</ng-container>
